import { ReactNode } from 'react';
import clsx from 'clsx';
import { SidebarToggle } from 'components/sidebar';
import feature from 'lib/utils/feature';

import './heading.scss';

interface Props {
	section?: ReactNode;
	title?: ReactNode;
	description?: ReactNode;
	/** Small pill after the title text, e.g. "Alpha". */
	badge?: ReactNode;
	className?: string;
}

export default function ContentHeading( props: Props ) {
	const { className, section, title, description, badge } = props;
	// The redesign fixes the heading outline: the page title is the h1 and the eyebrow is plain text.
	// The legacy page keeps its h2/h3 so nothing moves there.
	const isRedesign = feature( 'wpcloud-redesign' );
	const Title = isRedesign ? 'h1' : 'h2';
	const Eyebrow = isRedesign ? 'p' : 'h3';

	return (
		<div className={ clsx( 'content-heading', className ) }>
			<div className="flex items-center gap-2">
				<SidebarToggle />
				{ section && ( <Eyebrow className="content-heading__section">{ section }</Eyebrow> ) }
			</div>
			{ title && (
				<Title className="content-heading__title">
					{ title }
					{ badge && <span className="content-heading__badge">{ badge }</span> }
				</Title>
			) }
			{ description && ( <p className="content-heading__description">{ description }</p> ) }
		</div>
	);
}
